import styles from "./addExistingUserModal.module.scss";
import { ModalWindow } from "../../shared/components/modalWindow/modalWindow";
import { useTranslation } from "react-i18next";
import { AddExistingUserModalFirstStep } from "./addExistingUserModalFirstStep/addExistingUserModalFirstStep";
import {
  useEffect,
  useState
} from "react";
import {
  AssignUserToProject,
  UserToAssign
} from "../../types/user.types";
import { Project } from "../../types/project.types";
import { AddExistingUserModalSecondStep } from "./addExistingUserModalSecondStep/addExistingUserModalSecondStep";
import { useAssignUsersToProjectMutation } from "../../api/services/user.service";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { setShowSpinner } from "../../store/slices/mainSlice";

type AddExistingUserModalProps = {
  onClose: (isSave: boolean) => void;
}

export const AddExistingUserModal = ({ onClose }: AddExistingUserModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  const [selectedUsers, setSelectedUsers] = useState<Array<UserToAssign>>([]);
  const [selectedProject, setSelectedProject] = useState<Project>();
  const [isFirstStep, setIsFirstStep] = useState<boolean>(true);

  const [assignUsersToProject, { isLoading: isLoadingAssignUsersToProject, isSuccess: isSuccessAssignUsersToProject }] = useAssignUsersToProjectMutation();

  useEffect(() => {
    dispatch(setShowSpinner(isLoadingAssignUsersToProject));
  }, [isLoadingAssignUsersToProject]);

  useEffect(() => {
    if (isSuccessAssignUsersToProject) {
      onClose(true);
    }
  }, [isSuccessAssignUsersToProject]);

  const onClickContinue = (): void => {
    if (selectedProject) {
      setIsFirstStep(false);
    }
  }

  const onCancelSecondStep = (): void => {
    setIsFirstStep(true);
  }

  const onClickConfirm = (assignUsers: Array<AssignUserToProject>): void => {
    assignUsersToProject(assignUsers);
  }

  return (
    <ModalWindow title={t("admin.addExistingUserToProject")}
                 onClose={() => onClose(false)}
                 width={814}
                 children={(
                   <div className={styles.container}>
                     { isFirstStep ? (
                       <>
                         <AddExistingUserModalFirstStep selectedUsers={selectedUsers}
                                                        onChangeProject={setSelectedProject}
                                                        selectedProject={selectedProject}
                                                        onChangeSelectedUsers={setSelectedUsers}/>
                         <div className={styles.buttons}>
                           <button className={styles.cancel}
                                   onClick={() => onClose(false)}>{t("common.cancel")}</button>
                           <button className={styles.continue}
                                   disabled={selectedUsers.length === 0}
                                   onClick={onClickContinue}>{t("admin.continue")}</button>
                         </div>
                       </>
                     ) : selectedProject && (<AddExistingUserModalSecondStep selectedUsers={selectedUsers}
                                                                             project={selectedProject}
                                                                             onChangeSelectedUsers={setSelectedUsers}
                                                                             onCancelClick={onCancelSecondStep}
                                                                             onClickConfirm={onClickConfirm}/>)}
                   </div>
                 )}/>
  );
}